import React from 'react'
import { getStatusStyle } from '../../../../utils/drivers'

export const AdditionalWorkDaysView = ({ data }) => {
  const filteredData = data

  return (
    <React.Fragment>
      <div className='my-table'>
        <table className="table">
          <thead className="text-black font-bold text-left">
            <tr>
              <th style={{ width: '22%' }}>Employee</th>
              <th style={{ width: '18%' }}>Work Date</th>
              <th style={{ width: '13%' }}>Shift</th>
              <th style={{ width: '17%' }}>Status</th>
              <th style={{ width: '17%' }}>Created By</th>
              <th style={{ width: '13%' }}>Created On</th>
            </tr>
          </thead>
          <tbody>
            {
              filteredData.length > 0 ? filteredData.map(request => {
                const { text, backgroundColor } = getStatusStyle(request.status);
                return (
                  <tr key={request.id}>
                    <td style={{ verticalAlign: 'middle' }}>
                      {`${request.employee.user.first_name} ${request.employee.user.last_name} (${request.employee.user.username})`}
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.work_date}
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <div style={{ backgroundColor: request.shift.color, padding: 5, color: 'white', borderRadius: 3, fontSize: 12 }}>
                          {request.shift.name}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <div style={{ backgroundColor: backgroundColor, padding: 5, color: 'white', borderRadius: 3, fontSize: 12 }}>
                          {request.status_display}
                        </div>
                      </div>
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.created_by}
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.created_at ? request.created_at.split('T')[0] : ''}
                    </td>
                  </tr>
                )
              }

              ) : (
                <tr>
                  <td colSpan="6" className="text-center align-middle">
                    <div>No Data</div>
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </React.Fragment>

  )
}
